import React, { useState, useContext } from 'react'
import { Form, Button } from 'react-bootstrap'
import axios from 'axios'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { LOGIN_PATH } from '../../config/routes'
import config from '../../config/config'
import StarRatingSelector from '../StarRatingSelector'
import { useAuth, AuthContext } from '../../contexts/AuthContext'
import { setFlashMessage } from '../../contexts/WebsiteContext'

const PoiCommentForm = ({ poi, onCommentAdded }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { token, logout } = useAuth()
  const [text, setText] = useState('')
  const [rating, setRating] = useState(0)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const submit = async (e) => {
    e.preventDefault()
    setIsSubmitting(true)
    if (!rating && !text.trim()) {
      setFlashMessage(t('ERROR_EMPTY_COMMENT'), 'error')
      return
    }
    try {
      await axios.post(
        `${config.apiUrl}poi-comment`,
        { poi: poi.id, comment: text, rating },
        { headers: { Authorization: `Bearer ${token}` } },
      )
      setText('')
      setRating(0)
      onCommentAdded()
      setFlashMessage(t('SUCCESS_CREATED_COMMENT'), 'success')
      setIsSubmitting(false)
    } catch (err) {
      if (err.response?.status === 401) {
        logout()
        navigate(LOGIN_PATH)
      } else setFlashMessage(t('ERROR_MESSAGE'), 'error')

      setIsSubmitting(false)
    }
  }

  return (
    <div className="comment-form-card">
      <Form onSubmit={submit}>
        <Form.Group controlId="commentText">
          <Form.Label>{t('COMMENT')}:</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={text}
            onChange={(e) => setText(e.target.value)}
            placeholder={t('COMMENT_PLACEHOLDER')}
          />
        </Form.Group>

        <Form.Group controlId="commentRating" className="mt-3">
          <Form.Label>{t('COMMENT_RATING')}:</Form.Label>
          <StarRatingSelector rating={rating} onRatingChange={setRating} />
        </Form.Group>

        <div className="text-center mt-3">
          <Button
            type="submit"
            className="btn btn-primary"
            disabled={isSubmitting}
          >
            {t(isSubmitting ? 'SEND_IN_PROGRESS' : 'SEND')}
          </Button>
        </div>
      </Form>
    </div>
  )
}

export default PoiCommentForm
